<div class="widget" [ngClass]="{'loader-shown': loading}">
  <div class="widget-loader widget-loader-timeline">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-right-icon"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element loader-countdown"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-date"></div>
      <div class="loader-element loader-timeline-bar">
        <div class="loader-element loader-circle"></div>
        <div class="loader-element loader-circle"></div>
        <div class="loader-element loader-circle"></div>
        <div class="loader-element loader-circle"></div>
      </div>
    </div>
    <div class="widget-loader-bottom">
        <div class="loader-element loader-button"></div>
        <div class="loader-element loader-button-left"></div>
        <div class="loader-element loader-button-right"></div>
    </div>
  </div>
  <div class="widget-header">
    <span class="custom-icon">
      <span class="icon material-icons">schedule</span>
    </span>
    <span class="title">Timeline</span>
    <a
      *ngIf="widgetConfig.widgetSettings.showFullTimelineButton"
      href="{{FEUrl}}/timeline"
      class="full-timeline-link"
      pTooltip="Full Timeline"
    >
      <span class="icon material-icons">launch</span>
    </a>
  </div>
  <div class="widget-content">
    <p-carousel
      [value]="timelineSlides"
      [showIndicators]="false"
      [numVisible]="1"
      [numScroll]="1"
      (onPage)="onSlideChange($event)"
      [page]="firstSlideIndex"
    >
      <ng-template let-slide pTemplate="item">
        <div class="item-inner">
          <div class="timeline-countdown-wrapper" *ngIf="slide.showCountdown">
            <span
              class="timeline-countdown"
              [ngClass]="slide.calculatedCountdownClass"
            >
              {{ slide.calculatedCountdownText }}
            </span>
          </div>
          <h5 class="timeline-title">{{ slide.title }}</h5>
          <p class="timeline-date">{{ slide.dateLabel }}</p>
          <span class="button-container">
            <ng-container *ngIf="slide.showAddToCalendarButton">
              <button
                class="slide-button"
                [id]="'add-to-calendar-' + slide.title"
                (click)="addToCalendarClick(slide)"
              >
                Add to Calendar
              </button>
            </ng-container>
            <ng-container *ngIf="!slide.showAddToCalendarButton && (slide.buttonUrl && slide.buttonText)">
              <a
                class="slide-button"
                [href]="slide.buttonUrl"
                target="_blank"
              >
                {{ slide.buttonText }}
              </a>
            </ng-container>
          </span>
        </div>
      </ng-template>
    </p-carousel>
    <div class="timeline-bar-wrapper">
      <div class="timeline-line" [ngStyle]="{'transform': 'translateX(-' + timelineMilestoneBarPosition + '%)'}">
        <ng-container *ngFor="let slide of timelineSlides, let i = index">
          <div
            class="timeline-line-point"
            [ngStyle]="{'left': slide.milestonePositionInPercent + '%'}"
            [ngClass]="{'active': i === activeSlideIndex, 'passed': slide.milestonePassed === true}"
          >
            <span class="point"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>